import { ORDERS_UNPACK_FULFILLMENT_ORDER } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';

function useCanBeUnpacked() {
  return useHasTags([ORDERS_UNPACK_FULFILLMENT_ORDER])[0];
}

export default useCanBeUnpacked;
